import { useEffect } from "react";

export const useVirtualFastForward = (
  onFastForward: VoidFunction,
  onRewind: VoidFunction,
  enabled: boolean
) => {
  useEffect(() => {
    if (enabled) {
      const eventHandler = (event: KeyboardEvent) => {
        if (
          (window as any)["VK_FAST_FWD"] &&
          event.keyCode === (window as any)["VK_FAST_FWD"]
        ) {
          onFastForward();
        }
        if (
          (window as any)["VK_REWIND"] &&
          event.keyCode === (window as any)["VK_REWIND"]
        ) {
          onRewind();
        }
      };
      document.addEventListener("keydown", eventHandler);
      return () => document.removeEventListener("keydown", eventHandler);
    }
  }, [onFastForward, onRewind, enabled]);
};
